export const roundMoney = amount => {
  const roundedAmount = Math.round(amount * 100) / 100
  return Number(roundedAmount.toFixed(2))
}
